module.exports = __webpack_public_path__ + "static/media/next.8d727460.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/CasePeriod/imgs/next.svg
// module id = 599
// module chunks = 0